var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.label.length ? _c("h3", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.data, function (carriage, idx) {
        return _c("div", { key: idx, staticClass: "col-md-12 my-3" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("IcFormRowWrapper", {
                  attrs: {
                    rowElement: "IcFormRow",
                    id: "type",
                    name: "carriage.type",
                    label: _vm.$t("label_carriage_type"),
                    aria: _vm.$t("required"),
                    labelWidth: 4,
                    controlWidth: 8,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ validator }) {
                          return [
                            _c("IcSelect", {
                              attrs: {
                                id: "type",
                                values: _vm.carriageTypes(idx),
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInput(_vm.data, validator)
                                },
                              },
                              model: {
                                value: _vm.data[idx].type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.data[idx], "type", $$v)
                                },
                                expression: "data[idx].type",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.withCount
              ? _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("IcFormRowWrapper", {
                      attrs: {
                        rowElement: "IcFormRow",
                        id: "count",
                        name: "carriage.count",
                        aria: _vm.$t("aria_required"),
                        label: _vm.$t("label_count"),
                        labelWidth: 4,
                        controlWidth: 8,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ validator }) {
                              return [
                                _c("IcInput", {
                                  attrs: {
                                    id: "count",
                                    type: "number",
                                    maxlength: "20",
                                    readonly:
                                      _vm.data[idx].type ===
                                        "Wagon konferencyjny 507" ||
                                      _vm.data[idx].type ===
                                        "Wagon konferencyjny 508",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.emitInput(_vm.data, validator)
                                    },
                                  },
                                  model: {
                                    value: _vm.data[idx].count,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.data[idx], "count", $$v)
                                    },
                                    expression: "data[idx].count",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-2 d-flex align-items-center justify-content-start",
              },
              [
                idx > 0 || _vm.data.length > 1
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-danger pull-right",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.removeCarriage(idx)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "gg-remove" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Usuń wagon"),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    this.data.length < 6 && this.maxCarriages > this.data.length
      ? _c(
          "button",
          {
            staticClass: "btn btn-toggle btn-block btn-secondary",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.addCarriage()
              },
            },
          },
          [_vm._v("\n    \n    Dodaj wagon")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }